module.exports = __webpack_public_path__ + "img/us-tricounties.87404917.png";